// src/Mp3Player.js
import React, { useState, useRef } from "react";
import { Pause, PlayArrow } from "@mui/icons-material";

const Mp3Player = ({ song, name }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(song));

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  return (
    <div className="mp3-player">
      <div className="player-details">
        <p>MP3 by</p>
        <h2>{name}</h2>
      </div>
      <div className="controls">
        <button onClick={togglePlayPause} className="control-btn">
          {isPlaying ? <Pause /> : <PlayArrow />}
        </button>
      </div>
    </div>
  );
};

export default Mp3Player;
